export default __webpack_public_path__ + "static/media/typescript.76fe4b0a.svg";